// Welche Mail-Entwürfe sind gerade in einem Komposer offen? Der Feed zeigt nur Entwürfe, die niemand gerade bearbeitet, und
// lädt seine Liste neu, wenn ein Komposer einen Entwurf anlegt, ändert, sendet oder verwirft.
const offen = new Map<string, number>();
export const ENTWUERFE_GEAENDERT = "crm:mail-entwuerfe-geaendert";

export function entwurfOeffnen(id: string): () => void {
  offen.set(id, (offen.get(id) ?? 0) + 1);
  melden();
  return () => {
    const n = (offen.get(id) ?? 1) - 1;
    if (n <= 0) offen.delete(id);
    else offen.set(id, n);
    melden();
  };
}

export const istOffen = (id: string): boolean => offen.has(id);

/** Etwas an den Entwürfen hat sich geändert (Feed neu laden). */
export function melden(): void {
  window.dispatchEvent(new CustomEvent(ENTWUERFE_GEAENDERT));
}
